/* eslint-disable no-new no-alert, no-console, no-unused-vars, no-undef */
import Vue from "vue";
import VueRouter from "vue-router";
import Vuex from "vuex";
import VuexIdentity from "@/identity";
import VuexI18N from "vuex-i18n";

// Views
const login = () => import("@/views/pages/Login");
const dashboard = () => import("@/views/Dashboard");
const page404 = () => import("@/views/pages/Page404");
const notAuthorized = () => import("@/views/pages/NotAuthorized");

const layout = () => import("@/containers/Layout");
const layoutModule = () => import("@/views/containers/Layout");

const usersList = () => import("@/views/users/List");
const createUser = () => import("@/views/users/Create");

const suppliersList = () => import("@/views/suppliers/List");
const supplierShipmentsList = () => import("@/views/suppliers/Shipments");
const supplierCreateShipment = () => import("@/views/suppliers/createShipment");

const salesManList = () => import("@/views/salesMan/listSalesMan");
const clientList = () => import("@/views/salesMan/listClient");
const orderList = () => import("@/views/salesMan/listOrder");
const listOpenedOrderForSalesman = () =>
  import("@/views/salesman/listOpenedOrder");
const createClient = () => import("@/views/salesman/createClient");

const createOrder = () => import("@/views/salesMan/createOrder");

const salesmanReport = () => import("@/views/reports/salesmanReport");
const clientReport = () => import("@/views/reports/clientReport");
const detailedReport = () => import("@/views/reports/detailedReport");
const customReport = () => import("@/views/reports/customReport");

const configurationIndex = () => import("@/views/configuration/index");

// const gDriveCustomers = () => import("@/views/googleDrive/gDriveCustomers")

Vue.use(Vuex);

Vue.use(VueRouter);

const i18NStore = new Vuex.Store();
Vue.use(VuexI18N.plugin, i18NStore);

const identityStore = new Vuex.Store();
Vue.use(VuexIdentity.plugin, identityStore);

let vueRouter = new VueRouter({
  mode: "history", // Demo is living in GitHub.io, so required!
  linkActiveClass: "open active",
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [
    {
      path: "/",
      name: "Login",
      component: login
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: layout,
      children: [
        {
          path: "configuration",
          name: "configuration",
          meta: {
            authorizeRole: [
              Vue.identity.roles.superadmin,
              Vue.identity.roles.admin
            ]
          },
          component: configurationIndex
        },
        {
          path: "home",
          name: "Home",
          component: dashboard
        },
        {
          path: "users",
          name: "Users",
          component: layoutModule,
          meta: {
            authorizeRole: [
              Vue.identity.roles.superadmin,
              Vue.identity.roles.admin
            ]
          },
          redirect: "users/list",
          children: [
            {
              path: "list",
              name: "ListUser",
              component: usersList,
              meta: {
                authorizeRole: [
                  Vue.identity.roles.superadmin,
                  Vue.identity.roles.admin
                ]
              }
            },
            {
              path: "create",
              name: "CreateUser",
              component: createUser,
              meta: {
                authorizeRole: [
                  Vue.identity.roles.superadmin,
                  Vue.identity.roles.admin
                ]
              }
            },
            {
              path: "edit/:id",
              name: "EditUser",
              component: createUser,
              meta: {
                authorizeRole: [
                  Vue.identity.roles.superadmin,
                  Vue.identity.roles.admin
                ]
              }
            }
          ]
        },
        {
          path: "suppliers",
          name: "Suppliers",
          component: layoutModule,
          meta: {
            authorizeRole: [
              Vue.identity.roles.superadmin,
              Vue.identity.roles.admin
            ]
          },
          redirect: "suppliers/list",
          children: [
            {
              path: "list",
              name: "ListSupplier",
              component: suppliersList,
              props: {
                routingChild: {
                  edit: "ShipmentsSupplier"
                }
              },
              meta: {
                authorizeRole: [
                  Vue.identity.roles.superadmin,
                  Vue.identity.roles.admin
                ]
              },
              children: [
                {
                  path: "shipments/:idsupplier",
                  name: "ShipmentsSupplier",
                  component: supplierShipmentsList,
                  props: {
                    routingChild: {
                      create: "SupplierCreateShipment",
                      edit: "SupplierEditShipment"
                    }
                  },
                  meta: {
                    authorizeRole: [
                      Vue.identity.roles.superadmin,
                      Vue.identity.roles.admin
                    ]
                  },
                  children: [
                    {
                      path: "create/:idseason",
                      name: "SupplierCreateShipment",
                      component: supplierCreateShipment,
                      meta: {
                        authorizeRole: [
                          Vue.identity.roles.superadmin,
                          Vue.identity.roles.admin
                        ]
                      }
                    },
                    {
                      path: "edit/:idshipment",
                      name: "SupplierEditShipment",
                      component: supplierCreateShipment,
                      meta: {
                        authorizeRole: [
                          Vue.identity.roles.superadmin,
                          Vue.identity.roles.admin
                        ]
                      }
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          path: "shipments/:idsupplier",
          name: "ShipmentsSupplierForSuppliers",
          component: supplierShipmentsList,
          props: {
            routingChild: {
              create: "SupplierCreateShipmentForSuppliers",
              edit: "SupplierEditShipmentForSuppliers"
            }
          },
          meta: {
            authorizeRole: [
              Vue.identity.roles.superadmin,
              Vue.identity.roles.supplier
            ]
          },
          children: [
            {
              path: "create/:idseason",
              name: "SupplierCreateShipmentForSuppliers",
              component: supplierCreateShipment,
              meta: {
                authorizeRole: [
                  Vue.identity.roles.superadmin,
                  Vue.identity.roles.supplier
                ]
              }
            },
            {
              path: "edit/:idshipment",
              name: "SupplierEditShipmentForSuppliers",
              component: supplierCreateShipment,
              meta: {
                authorizeRole: [
                  Vue.identity.roles.superadmin,
                  Vue.identity.roles.supplier
                ]
              }
            }
          ]
        },
        {
          path: "salesmans",
          name: "Salesmans",
          component: layoutModule,
          meta: {
            authorizeRole: [
              Vue.identity.roles.superadmin,
              Vue.identity.roles.admin
            ]
          },
          redirect: "salesmans/list",
          children: [
            {
              path: "list",
              name: "listSalesman",
              component: salesManList,
              props: {
                routingChild: {
                  edit: "listClient"
                }
              },
              meta: {
                authorizeRole: [
                  Vue.identity.roles.superadmin,
                  Vue.identity.roles.admin
                ]
              },
              children: [
                {
                  path: ":idsalesman/clients",
                  name: "listClient",
                  component: clientList,
                  props: {
                    routingChild: {
                      edit: "listOrder"
                    }
                  },
                  meta: {
                    authorizeRole: [
                      Vue.identity.roles.superadmin,
                      Vue.identity.roles.admin
                    ]
                  },
                  children: [
                    {
                      path: ":idclient/orders",
                      name: "listOrder",
                      component: orderList,
                      props: {
                        routingChild: {
                          create: "createOrder",
                          edit: "editOrder"
                        }
                      },
                      meta: {
                        authorizeRole: [
                          Vue.identity.roles.superadmin,
                          Vue.identity.roles.admin
                        ]
                      },
                      children: [
                        {
                          path: "edit/:idorder",
                          name: "editOrder",
                          component: createOrder,
                          meta: {
                            authorizeRole: [
                              Vue.identity.roles.superadmin,
                              Vue.identity.roles.admin,
                              Vue.identity.roles.salesman
                            ]
                          }
                        },
                        {
                          path: ":idseason/create",
                          name: "createOrder",
                          component: createOrder,
                          meta: {
                            authorizeRole: [
                              Vue.identity.roles.superadmin,
                              Vue.identity.roles.admin
                            ]
                          }
                        }
                      ]
                    }
                  ]
                },
                {
                  path: ":idsalesman/createClient",
                  name: "CreateClient",
                  component: createClient,
                  meta: {
                    authorizeRole: [
                      Vue.identity.roles.superadmin,
                      Vue.identity.roles.admin,
                      Vue.identity.roles.salesman
                    ]
                  }
                },
                {
                  path: ":idsalesman/editClient/:id",
                  name: "EditClient",
                  component: createClient,
                  meta: {
                    authorizeRole: [
                      Vue.identity.roles.superadmin,
                      Vue.identity.roles.admin,
                      Vue.identity.roles.salesman
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          path: "clients",
          name: "listAllClient",
          component: clientList,
          props: {
            routingChild: {
              edit: "listOrderClient"
            }
          },
          meta: {
            authorizeRole: [
              Vue.identity.roles.superadmin,
              Vue.identity.roles.admin
            ]
          },
          children: [
            {
              path: ":idclient/orders",
              name: "listOrderClient",
              component: orderList,
              props: {
                routingChild: {
                  create: "createOrderClient",
                  edit: "editOrderClient",
                  print: "printOrderClient"
                }
              },
              meta: {
                authorizeRole: [
                  Vue.identity.roles.superadmin,
                  Vue.identity.roles.admin
                ]
              },
              children: [
                {
                  path: "edit/:idorder",
                  name: "editOrderClient",
                  component: createOrder,
                  meta: {
                    authorizeRole: [
                      Vue.identity.roles.superadmin,
                      Vue.identity.roles.admin
                    ]
                  }
                },
                {
                  path: ":idseason/create",
                  name: "createOrderClient",
                  component: createOrder,
                  meta: {
                    authorizeRole: [
                      Vue.identity.roles.superadmin,
                      Vue.identity.roles.admin
                    ]
                  }
                }
              ]
            }
          ]
        },
        //{
        //  path: 'orders',
        //  name: 'listAllOrders',
        //  component: orderList,
        //  props: { routingChild: { create: 'createOrderAdmin', edit: 'editOrderAdmin' } },
        //  meta: { authorizeRole: [Vue.identity.roles.superadmin, Vue.identity.roles.admin] },
        //  children: [
        //    {
        //      path: 'edit/:idorder',
        //      name: 'editOrderAdmin',
        //      component: createOrder,
        //      meta: { authorizeRole: [Vue.identity.roles.superadmin, Vue.identity.roles.admin] }
        //    },
        //    {
        //      path: ':idseason/create',
        //      name: 'createOrderAdmin',
        //      component: createOrder,
        //      meta: { authorizeRole: [Vue.identity.roles.superadmin, Vue.identity.roles.admin] }
        //    }
        //  ]
        //},
        {
          path: ":idsalesman/openedOrders",
          name: "listOpenedOrderForSalesman",
          component: listOpenedOrderForSalesman,
          props: {
            routingChild: {
              create: "createOpenedOrderForSalesman",
              edit: "editOpenedOrderForSalesman"
            }
          },
          meta: {
            authorizeRole: [
              Vue.identity.roles.superadmin,
              Vue.identity.roles.admin,
              Vue.identity.roles.salesman
            ]
          },
          children: [
            {
              path: "edit/:idorder",
              name: "editOpenedOrderForSalesman",
              component: createOrder,
              meta: {
                authorizeRole: [
                  Vue.identity.roles.superadmin,
                  Vue.identity.roles.admin,
                  Vue.identity.roles.salesman
                ]
              }
            }
          ]
        },
        {
          path: ":idsalesman/clients",
          name: "listClientForSalesman",
          component: clientList,
          props: {
            routingChild: {
              edit: "listOrderForSalesman"
            }
          },
          meta: {
            authorizeRole: [
              Vue.identity.roles.superadmin,
              Vue.identity.roles.admin,
              Vue.identity.roles.salesman
            ]
          },
          children: [
            {
              path: ":idclient/orders",
              name: "listOrderForSalesman",
              component: orderList,
              props: {
                routingChild: {
                  create: "createOrderForSalesman",
                  edit: "editOrderForSalesman"
                }
              },
              meta: {
                authorizeRole: [
                  Vue.identity.roles.superadmin,
                  Vue.identity.roles.admin,
                  Vue.identity.roles.salesman,
                  Vue.identity.roles.customer
                ]
              },
              children: [
                {
                  path: "edit/:idorder",
                  name: "editOrderForSalesman",
                  component: createOrder,
                  meta: {
                    authorizeRole: [
                      Vue.identity.roles.superadmin,
                      Vue.identity.roles.salesman
                    ]
                  }
                },
                {
                  path: ":idseason/create",
                  name: "createOrderForSalesman",
                  component: createOrder,
                  meta: {
                    authorizeRole: [
                      Vue.identity.roles.superadmin,
                      Vue.identity.roles.salesman
                    ]
                  }
                }
              ]
            }
          ]
        },
        {
          path: ":idclient/orders",
          name: "listOrderForClient",
          component: orderList,
          props: {
            routingChild: {
              create: "createOrderForClient",
              edit: "editOrderForClient"
            }
          },
          meta: {
            authorizeRole: [
              Vue.identity.roles.superadmin,
              Vue.identity.roles.customer
            ]
          },
          children: [
            {
              path: "edit/:idorder",
              name: "editOrderForClient",
              component: createOrder,
              meta: {
                authorizeRole: [
                  Vue.identity.roles.superadmin,
                  Vue.identity.roles.customer
                ]
              }
            },
            {
              path: ":idseason/create",
              name: "createOrderForClient",
              component: createOrder,
              meta: {
                authorizeRole: [
                  Vue.identity.roles.superadmin,
                  Vue.identity.roles.customer
                ]
              }
            }
          ]
        },
        {
          path: "salesmanReport",
          name: "salesmanReport",
          meta: {
            authorizeRole: [
              Vue.identity.roles.superadmin,
              Vue.identity.roles.admin,
              Vue.identity.roles.salesman
            ]
          },
          component: salesmanReport
        },
        {
          path: "clientReport",
          name: "clientReport",
          meta: {
            authorizeRole: [
              Vue.identity.roles.superadmin,
              Vue.identity.roles.admin,
              Vue.identity.roles.customer
            ]
          },
          component: clientReport
        },
        {
          path: "detailedReport",
          name: "detailedReport",
          meta: {
            authorizeRole: [
              Vue.identity.roles.superadmin,
              Vue.identity.roles.admin,
              Vue.identity.roles.customer
            ]
          },
          component: detailedReport
        },
        {
          path: "customReport",
          name: "customReport",
          meta: {
            authorizeRole: [
              Vue.identity.roles.superadmin,
              Vue.identity.roles.admin
            ]
          },
          component: customReport
        },
        // {
        //   path: "gDriveCustomers",
        //   name: "gDriveCustomers",
        //   meta: {
        //     authorizeRole: [
        //       Vue.identity.roles.superadmin,
        //       Vue.identity.roles.admin,
        //     ],
        //   },
        //   component: gDriveCustomers,
        // },
        {
          path: "not-authorized",
          name: "NotAuthorized",
          component: notAuthorized
        },
        {
          path: "*",
          name: "Page404",
          component: page404
        }
      ]
    }
  ]
});

vueRouter.beforeEach((to, from, next) => {
  Vue.identity.validedToken(to, Vue.i18n.locale()).then(response => {
    next(response);
  });
});

export default vueRouter;



// WEBPACK FOOTER //
// ./src/router/index.js